import {useMutation, UseMutationOptions, useQueryClient, InfiniteData} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {httpDeleteConversation} from '../http/conversations.http'
import {ConversationsList} from '@/features/conversations/types'
import {QUERY_KEYS} from '@/queryClient'

export const useDeleteConversation = (
    patientId: string | null,
    options?: UseMutationOptions<void, AxiosError, string>
) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: async (conversationId: string) => {
            await httpDeleteConversation(conversationId)
        },
        onSuccess: (data, conversationId, context) => {
            queryClient.setQueriesData(
                {
                    queryKey: [QUERY_KEYS.CONVERSATIONS, patientId],
                    exact: false
                },
                (oldData: InfiniteData<{data: ConversationsList}> | undefined) => {
                    if (!oldData) return oldData

                    const updatedPages = oldData.pages.map(page => ({
                        ...page,
                        data: {
                            ...page.data,
                            data: page.data.data.filter(conversation => conversation.id !== conversationId),
                            meta: {
                                ...page.data.meta,
                                total: Math.max(0, page.data.meta.total - 1)
                            }
                        }
                    }))

                    return {
                        ...oldData,
                        pages: updatedPages
                    }
                }
            )

            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.CONVERSATIONS, patientId]
            })

            options?.onSuccess?.(data, conversationId, context)
        },
        onError: options?.onError,
        onMutate: options?.onMutate,
        onSettled: options?.onSettled
    })
}
